var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-btn',{attrs:{"flat":""},nativeOn:{"click":function($event){_vm.openDialog()}}},[_vm._v("\n    Feedback\n  ")]),_c('submit-dialog',{attrs:{"visible":_vm.getIsDialogDisplayed()}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }